import { render, staticRenderFns } from "./edit-main.vue?vue&type=template&id=83d867bc"
import script from "./edit-main.vue?vue&type=script&lang=js"
export * from "./edit-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports